import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap items-center gap-[6px]',
    unit: 'flex-center bg-blue-light heading-s group relative flex h-9 min-w-[74px] cursor-pointer rounded-[100px] border border-transparent px-[14px]',
    notice:
      'bg-secondary-hover heading-xs-bold flex-center absolute top-6 -right-28 z-10 flex h-6 rounded-[100px] px-2 whitespace-nowrap text-white opacity-0 duration-300 group-hover:opacity-100',
    notVisibleOptions: 'heading-s max-lg:hidden',
    notVisibleOptionsMobile: 'heading-s lg:hidden'
  },
  variants: {
    size: {
      l: {},
      s: {
        unit: 'heading-xs h-6 min-w-[44px] px-2',
        notVisibleOptions: 'heading-xs'
      }
    },
    inactive: {
      true: {
        unit: 'text-inactive'
      }
    },
    selected: {
      true: {
        unit: 'bg-blue-dark text-white'
      }
    },
    selectedInactive: {
      true: {
        unit: 'text-inactive border-blue-dark'
      }
    },
    hiddenMobile: {
      true: {
        unit: 'max-lg:hidden'
      }
    }
  },
  defaultVariants: {
    size: 'l'
  }
});
